import $ from 'jquery';

$(() => {
	var parsleyConfig = {
		trigger: 'change',
		errorClass: 'has-danger',
		classHandler: function (el) {
			return el.$element.closest('.form-group');
		},
		errorsContainer: function (el) {
			return el.$element.closest('.form-group');
		},
		errorsWrapper: '<span class="label-help"></span>'
	};
	if($('#unsubscribe-form').length > 0){
		console.log('unsubscribe');
		$('#unsubscribe-form').parsley(parsleyConfig);
	}
});
